import { Component, NgZone, ChangeDetectorRef } from '@angular/core';
import { AuthService } from './services/auth.service';
import { MenuController } from '@ionic/angular';

import { SyncService } from './services/sync';
import { Storage } from '@ionic/storage-angular';
import { SwUpdate } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {
  
  isOnline: boolean = navigator.onLine;

  constructor(
    private authService: AuthService,
    private menuCtrl: MenuController,
    private syncService: SyncService,
    private storage: Storage,
    private swUpdate: SwUpdate,
    private zone: NgZone,             // 💡 Inyectado para actualizar interfaz en móviles
    private cd: ChangeDetectorRef     // 💡 Inyectado para forzar renderizado
  ) {
    this.initializeApp();
    this.escucharEstadoRed();
  }

  async initializeApp() {
    await this.storage.create();
    console.log(' Base de datos local inicializada con éxito');

    this.verificarActualizacionesPWA();
    this.syncService.init();
  }
  
  // 💡 Detección garantizada para navegadores móviles y webviews
  escucharEstadoRed() {
    window.addEventListener('online', () => {
      this.zone.run(() => {
        this.isOnline = true;
        this.cd.detectChanges();
      });
    });
    
    window.addEventListener('offline', () => {
      this.zone.run(() => {
        this.isOnline = false;
        this.cd.detectChanges();
      });
    });
  }

  verificarActualizacionesPWA() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          console.log(' Nueva versión detectada. Recargando la PWA...');
          window.location.reload();
        }
      });
    }
  }

  obtenerRolActual(): string {
    const rol = this.authService.getRol();
    return rol ? rol.toLowerCase() : '';
  }

  esAdministrador(): boolean {
    const rol = this.obtenerRolActual();
    return rol.includes('administrador') || rol.includes('admin');
  }

  esVendedor(): boolean {
    return this.obtenerRolActual().includes('vendedor');
  }

  esAlmacen(): boolean {
    return this.obtenerRolActual().includes('almacen');
  }

  esTecnico(): boolean {
    return this.obtenerRolActual().includes('tecnico');
  }

  //  Permiso especial para Carlos y Uriel
  esCarlosOUriel(): boolean {
    const userStr = localStorage.getItem('user');
    if (!userStr) return false;
    const user = JSON.parse(userStr);
    const username = (user.username || user.email || '').toUpperCase();
    return username.includes('CARLOS') || username.includes('URIEL');
  }

  esMartha(): boolean {
    const userStr = localStorage.getItem('user');
    if (!userStr) return false;
    const user = JSON.parse(userStr);
    const username = (user.username || user.email || '').toLowerCase();
    const rol = (user.rol || user.role?.name || '').toLowerCase();

    return username.includes('martha') || username.includes('marta') || rol === 'contabilidad' || rol === 'administracion';
  }

  esAdminMaestro(): boolean {
    return this.esAdministrador() && !this.esMartha();
  }

  cerrarSesion() {
    this.menuCtrl.close();
    this.authService.logout();
  }
}